import React, { useEffect } from 'react';
import { Grid, styled } from '@mui/material';
import { BsArrowRight } from 'react-icons/bs';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from 'src/hooks';

const StyledLink = styled(Link)``;

interface TabNavigationLinksProps {
  onBreadcrumbClick?: (routeURL: string) => boolean;
}

export default function TabNavigationLinks({ onBreadcrumbClick }: TabNavigationLinksProps) {
  const { dynamicBreadcrumbs, currentScenario } = useAppSelector(
    (state) => state.simulatorHome
  );

  const { id: currentScenarioId } = useParams();

  const handleClick = (e: React.MouseEvent, routeURL: string) => {
    if (onBreadcrumbClick) {
      const shouldProceed = onBreadcrumbClick(routeURL);
      if (!shouldProceed) {
        e.preventDefault();
      }
    }
  };

  const visibleBreacrumbs = dynamicBreadcrumbs.filter( (breadcrumb) => {
  const pageAlias = breadcrumb.page.alias;
  const routeUrl = breadcrumb.page.route_url;

  const isPlannerSimulatorBreadcrumb = pageAlias === "Planner & Simulator" || routeUrl?.endsWith("planner-simulator")
  const isPlannerBreadcrumb = pageAlias === "Planner" || routeUrl?.endsWith("/planner");

  if (isPlannerSimulatorBreadcrumb) {
    return false
  }

  if ( currentScenario?.planner_included === false && isPlannerBreadcrumb ) {
    return false;
  }

  return true;
  });

  return (
    <Grid container>
      {visibleBreacrumbs.map((breadcrumb, index) => {
          const routeURL = breadcrumb.page.route_url.replace(':id', currentScenarioId);
          return (
            <Grid item xs='auto' mr={1} container alignItems='center' key={routeURL}>
              <StyledLink
                sx={{
                  mr: 1,
                  color: window.location.pathname === routeURL ? '#ff6400' : 'grey',
                  fontSize: '10px',
                  fontWeight: window.location.pathname === routeURL ? 700 : 400,
                  pointerEvents: currentScenario ? 'all' : 'none',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                to={routeURL}
                onClick={(e) => handleClick(e, routeURL)}
              >
                {breadcrumb.page.alias}
              </StyledLink>
              {index !== visibleBreacrumbs.length - 1 ? <BsArrowRight /> : null}
            </Grid>
          );
      })}
    </Grid>
  );
}